import React from 'react';
import { AppSkeletonImage } from '../../common/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/list-app-skeleton.tpl.svg';
import embedImgSVG from './assets/list-embed-app-skeleton.tpl.svg';

export const ListSkeleton = () => <AppSkeletonImage src={imgSVG} />;

export const ListEmbedSkeleton = () => <AppSkeletonImage src={embedImgSVG} />;
